function voicePrompt(text) {
  new Audio(
    "http://tts.baidu.com/text2audio?lan=zh&ie=UTF-8&spd=2&text=" + text
  ).play();
}

export { voicePrompt };



// WEBPACK FOOTER //
// ./src/utils/voicePrompt.js